import { useQuery } from '@apollo/client/react';

import { listQuery } from '../../services/ShopService';

export const useShops = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { shops: data?.shops ?? [], loading, error };
};
